module.exports = __webpack_public_path__ + "img/central-electric.c407c551.jpg";